import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, SortDirection} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FabTableState, filterStateChange} from '@fabric/components/table-filter/data-query';
import {catchError, EMPTY, map, Observable} from 'rxjs';
import {OtdsFileLog} from '../../../models/OtdsFileLog';
import {NotificationService} from '../../../services/notification.service';
import {OtdsErrorService} from '../../../services/otds-error.service';
import {SecurityService} from '../../../services/security.service';
import {
  FabDateFilterOperator,
  RemDateFilterComponent
} from '../../../shared-components/table-filter/date-filter/date-filter.component';
import {
  FabStringFilterOperator,
  RemStringFilterComponent
} from '../../../shared-components/table-filter/string-filter/string-filter.component';

@Component({
  selector: 'app-otds-error-log',
  templateUrl: './otds-error-log.component.html',
  styleUrls: ['./otds-error-log.component.scss']
})
export class OtdsErrorLogComponent implements OnInit {

  selector: string;
  isLoading: boolean = false;
  initialLoadingCompleted = false;

  displayedColumns: string[] = ['nombreDeArchivo', 'fecProceso', 'message'];
  dataSource: MatTableDataSource<OtdsFileLog> = new MatTableDataSource<OtdsFileLog>();
  otdsFileLogs: OtdsFileLog[] = [];
  operators: FabStringFilterOperator[] = ['contains'];
  dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };

  @ViewChild(MatSort) matSort: MatSort;
  initialSortField = 'fecProceso';
  initialSortDirection: SortDirection = 'desc';

  @ViewChild(MatPaginator) matPaginator: MatPaginator;
  pageSizes = [10, 15, 20, 25];
  totalElements: number = 0;

  @ViewChild('dataTable', {read: ElementRef}) dataTable: ElementRef;

  @ViewChildren('tableFilter') tableFilters: QueryList<RemStringFilterComponent | RemDateFilterComponent>;


  constructor(private readonly otdsErrorService: OtdsErrorService,
              private readonly notificationService: NotificationService,
              private securityService: SecurityService,
              private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  ngAfterViewInit(): void {
    this.fetchInitialData();
  }

  private fetchInitialData() {
    this.isLoading = true;
    this.initialLoadingCompleted = false;
    this.matSort.active = this.initialSortField;
    this.matSort.direction = this.initialSortDirection;
    this.tableFilters.toArray().forEach((x) => x.clearFilter());
    this.matSort.sortChange.emit();
    this.requestPage().subscribe(() => {
      this.isLoading = false;
      this.initialLoadingCompleted = true;
    });
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    this.state.filter = filterStateChange(event, this.state.filter ?? []);
    this.updatePageState();
  }

  private requestPage(): Observable<any> {
    return this.otdsErrorService.getFileLogPage(
      this.matPaginator.pageIndex,
      this.matPaginator.pageSize,
      [this.matSort.active],
      this.matSort.direction,
      this.state.filter ?? []
    ).pipe(
      map((response) => {
        this.otdsFileLogs = response.data;
        this.dataSource = new MatTableDataSource<OtdsFileLog>(this.otdsFileLogs);
        this.totalElements = response.total;
        this.matPaginator.pageIndex = response.page;
        this.matPaginator.pageSize = response.pageSize;
        this.scrollTableToTop();
        return EMPTY;
      }), catchError((error) => {
        this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), 'error');
        this.otdsFileLogs = [];
        this.dataSource = new MatTableDataSource<OtdsFileLog>([]);
        this.totalElements = 0;
        return EMPTY;
      })
    );
  }

  updatePageState() {
    if (this.initialLoadingCompleted) {
      this.isLoading = true;
      this.requestPage().subscribe(() => {
        this.isLoading = false;
      });
    }
  }

  onSortChange() {
    this.matPaginator.pageIndex = 0;
    this.updatePageState();
  }

  scrollTableToTop() {
    this.dataTable.nativeElement.scrollIntoView();
  }
}
